import { DESIGNER_ACTIONS } from "./designerState";
import { getPrintLocationKeyFromSelection } from "./designerHelpers";

export const cmdSetActivePart = ({ dispatch, partKey }) => {
    dispatch({ type: DESIGNER_ACTIONS.SET_ACTIVE_PART, partKey });
};

export const cmdSetActivePrint = ({ dispatch, printKey }) => {
    dispatch({ type: DESIGNER_ACTIONS.SET_ACTIVE_PRINT, printKey });
};

export const cmdSetViewSide = ({ dispatch, viewSide }) => {
    dispatch({ type: DESIGNER_ACTIONS.SET_VIEW_SIDE, viewSide });
};

export const cmdTogglePart = ({
    dispatch,
    partKey,
    selected,
    treeContext,
}) => {
    dispatch({
        type: DESIGNER_ACTIONS.TOGGLE_PART,
        partKey,
        selected,
        context: treeContext,
        requiredKeys: treeContext.requiredKeys,
    });
    if (selected) {
        cmdSetActivePart({ dispatch, partKey });
    }
};

export const cmdSelectMaterial = ({
  dispatch,
  partKey,
  materialId,
  treeContext = null,
}) => {
  dispatch({
    type: DESIGNER_ACTIONS.SELECT_MATERIAL,
    partKey,
    materialId,
    context: treeContext,
  });
};

export const cmdSelectColor = ({
  dispatch,
  partKey,
  materialId,
  colorObj,
  treeContext = null,
}) => {
  dispatch({
    type: DESIGNER_ACTIONS.SELECT_COLOR,
    partKey,
    materialId,
    colorObj,
    context: treeContext,
  });
};

export const cmdClearColor = ({ dispatch, partKey, materialId }) => {
    dispatch({
        type: DESIGNER_ACTIONS.CLEAR_COLOR,
        partKey,
        materialId,
    });
};

export const cmdSetPrintFilter = ({ dispatch, partKey, filterName, value }) => {
    dispatch({
        type: DESIGNER_ACTIONS.SET_PRINT_FILTER,
        partKey,
        filterName,
        value,
    });
};

export const cmdSelectPrint = ({
    dispatch,
    treeContext,
    preloadPrintDetailsByIds,
    printKey,
    locationKey,
    print,
    side,
    initialAttrs,
}) => {
    dispatch({
        type: DESIGNER_ACTIONS.SELECT_PRINT,
        partKey: printKey,
        locationKey,
        print,
        side,
        initialAttrs,
        context: treeContext,
    });
    preloadPrintDetailsByIds([print?.id]);
};

export const cmdSetPrintMode = ({
    dispatch,
    printKey,
    mode,
    selectedPrints = {},
}) => {
    const normalizedPrintKey = String(printKey || "");
    if (!normalizedPrintKey) return;
    dispatch({ type: DESIGNER_ACTIONS.SET_PRINT_MODE, partKey: normalizedPrintKey, mode });
    const locationKey = getPrintLocationKeyFromSelection(
        normalizedPrintKey,
        selectedPrints[normalizedPrintKey]
    );
    cmdSetPrintFilter({
        dispatch,
        partKey: locationKey,
        filterName: "mode",
        value: mode,
    });
};

export const cmdSetPrintText = ({ dispatch, partKey, text }) => {
    dispatch({
        type: DESIGNER_ACTIONS.SET_PRINT_TEXT,
        partKey,
        text,
    });
};

export const cmdSetPrintImage = ({ dispatch, partKey, imageUrl, imageMode }) => {
    dispatch({
        type: DESIGNER_ACTIONS.SET_PRINT_IMAGE,
        partKey,
        imageUrl,
        imageMode,
    });
};

export const cmdSetPrintFont = ({ dispatch, partKey, fontId }) => {
    dispatch({ type: DESIGNER_ACTIONS.SET_PRINT_FONT, partKey, fontId });
};

export const cmdSetPrintColor = ({ dispatch, partKey, colorObj, colorIndex }) => {
    dispatch({
        type: DESIGNER_ACTIONS.SET_PRINT_COLOR,
        partKey,
        colorObj,
        colorIndex,
    });
};

export const cmdMergePrintAttrs = ({ dispatch, partKey, attrs, context = null }) => {
    dispatch({ type: DESIGNER_ACTIONS.MERGE_PRINT_ATTRS, partKey, attrs, context });
};

export const cmdClearPrint = ({ dispatch, printKey, selectedPrints = {} }) => {
    const normalizedPrintKey = String(printKey || "");
    if (!normalizedPrintKey) return;
    const locationKey = getPrintLocationKeyFromSelection(normalizedPrintKey, selectedPrints[normalizedPrintKey]);
    const remainingInLocation = Object.keys(selectedPrints || {}).filter(
        (key) =>
            key !== normalizedPrintKey
            && getPrintLocationKeyFromSelection(key, selectedPrints[key]) === locationKey
    );
    dispatch({ type: DESIGNER_ACTIONS.CLEAR_PRINT, partKey: normalizedPrintKey });
    cmdSetActivePrint({
        dispatch,
        printKey: remainingInLocation[0] || locationKey || null,
    });
};
